export const BUILD_NUMBER = '7a26d1'; export const SEQUENTIAL_BUILD_NUMBER = '1441'; export const PACKAGE_VERSION = '3.4.0';export const SELECTED_THEME = 'smartcr';
